import { Flag, Truck, Medal, Camera, Star, Route, Zap, Award } from "lucide-react";

const ICONS = { flag: Flag, truck: Truck, medal: Medal, camera: Camera, star: Star, route: Route, zap: Zap, award: Award };
const COLORS = { first_run: "text-emerald-300 border-emerald-500/30 bg-emerald-500/10", road_warrior: "text-cyan-300 border-cyan-500/30 bg-cyan-500/10",
  century: "text-amber-300 border-amber-500/30 bg-amber-500/10", photo_pro: "text-pink-300 border-pink-500/30 bg-pink-500/10",
  five_star: "text-amber-200 border-amber-400/40 bg-amber-400/10", multi_stop: "text-violet-300 border-violet-500/30 bg-violet-500/10", priority: "text-amber-300 border-amber-500/30 bg-amber-500/10" };

export function Badge({ b, compact = false }) {
  const I = ICONS[b.icon] || Medal;
  return (
    <span title={b.desc} data-testid={`badge-${b.key}`} className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] font-mono uppercase ${COLORS[b.key] || "text-slate-300 border-slate-700"}`}>
      <I className="w-3 h-3" />{!compact && b.label}
    </span>
  );
}

export default function DriverBadges({ badges = [], next, compact = false }) {
  if (badges.length === 0 && !next) return null;
  return (
    <div className="space-y-1.5" data-testid="driver-badges">
      <div className="flex flex-wrap gap-1">{badges.map((b) => <Badge key={b.key} b={b} compact={compact} />)}</div>
      {next && !compact && (
        <div data-testid="next-badge">
          <p className="text-[11px] text-slate-400">Next: <span className="text-slate-200">{next.label}</span> · {next.progress}/{next.goal}</p>
          <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden mt-1"><div className="h-full bg-gradient-to-r from-blue-500 to-cyan-400" style={{ width: `${Math.min(100, (next.progress / next.goal) * 100)}%` }} /></div>
        </div>
      )}
    </div>
  );
}
